import React from "react";
import styled, { withTheme } from "styled-components";
import { connect } from "react-redux";
import { selectors as booksSelectors } from "../../../../../redux/books";
import { Translation, t } from "../../../../core/translate";
import { BookCoverIconOverlay } from "../../book/BookIcons";
import CoursewareIcon from "../../../library/icons/courseware/coursewareIcon";
import { selectors as ancillarySelectors } from "../../../../../redux/ancillaries";
import { selectors as bridgeSelectors } from "../../../../../redux/bridge";
import { selectors as routerSelectors } from "../../../../../redux/router";
import Cover from "../../book/cover";
import * as bookActions from "../../../../../redux/book/actions";
import { Button } from "@vitalsource/vstui";
import Spinner from "../../../../../components/layouts/spinner";
import ClosePanelButton from "../../../../../ui/components/screen-reader-close";
import { TextEllipsis } from "../../../../components/text-ellipsis";
import { showTranslatedEdition } from "../../../../../redux/bridge/utils";

const Wrapper = styled.div`
  background-color: ${props => props.theme.color.base.getShade(8)};
  display: flex;
  min-height: 176px;
  padding: 30px 20px;
  align-items: center;
`;

const CoverContainer = styled.div`
  position: relative;
`;

const PanelBookCoverOverlay = styled(BookCoverIconOverlay)`
  height: 100%;
  width: 100%;
  max-height: 105px;
`;

const PanelOverlayIcon = styled(CoursewareIcon)`
  height: 54px;
`;

const Info = styled.div`
  color: #ffffff;
  padding-left: 15px;
  max-width: 285px;
  width: 100%;
  .bookTitle {
    font-size: 1.8rem;
    font-weight: 400;
    margin: 0;
  }
`;

const Author = styled.p`
  font-size: 1.4rem;
  margin: 10px 0;
  font-weight: 300;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

const bookCover = (accessCode, isbn, bookTitle) => {
  const coverImage = (
    <Cover bookTitle={bookTitle} isbn={isbn} width={81} altText="" />
  );

  if (accessCode) {
    return (
      <CoverContainer>
        <PanelBookCoverOverlay>
          <PanelOverlayIcon />
        </PanelBookCoverOverlay>
        {coverImage}
      </CoverContainer>
    );
  }
  return coverImage;
};

const Header = ({
  isbn,
  book,
  accessCode,
  openBook,
  theme,
  isActive,
  isLicensedBook,
  hasUnlimitedAccess,
  distributable
}) => {
  const showTranslated = showTranslatedEdition(book.edition);
  const bookTitle = showTranslated
    ? `${book.title}, ${t("library.book.edition-number", "Edition", {
        edition: book.edition
      })}`
    : book.title;

  if (book && bookTitle) {
    return (
      <Wrapper>
        {bookCover(accessCode, isbn, bookTitle)}
        <ClosePanelButton />
        <Info>
          <TextEllipsis
            position="bottom"
            toolTipText={bookTitle.decodeHTML()}
            lines={2}
          >
            <p className="bookTitle">{bookTitle.decodeHTML()}</p>
          </TextEllipsis>
          <Author>{book.author}</Author>
          {(isActive ||
            isLicensedBook ||
            (distributable && hasUnlimitedAccess)) && (
            <Button
              color="white"
              colorBehindButton={theme.color.base.getShade(8)}
              onClick={openBook}
            >
              <Translation id="library.open-book">Open Book</Translation>
            </Button>
          )}
        </Info>
      </Wrapper>
    );
  } else {
    return (
      <Wrapper>
        {bookCover(accessCode, isbn, bookTitle)}
        <Spinner />
      </Wrapper>
    );
  }
};

const jigsawMapStateToProps = (state, props) => ({
  book: booksSelectors.getBookByIsbn(state, props.isbn),
  accessCode: ancillarySelectors.getAccessCodesForVbid(state, props.isbn),
  isLicensedBook: booksSelectors.isLicensedBook(state, props.isbn)
});

const jigsawMapDispatchToProps = (dispatch, props) => ({
  openBook: () =>
    dispatch(
      bookActions.launchLicensedBook(props.isbn, {
        context: `licensed-book-details-panel ${props.context}`
      })
    )
});

const bridgeMapStateToProps = (state, props) => ({
  book: bridgeSelectors.getAsset(state, props.isbn),
  isActive: bridgeSelectors.isActive(state, props.isbn),
  hasUnlimitedAccess: bridgeSelectors.hasUnlimitedAccess(state, props.isbn),
  distributable: bridgeSelectors.isDistributable(state, props.isbn)
});

const bridgeMapDispatchToProps = (dispatch, props) => ({
  openBook: () =>
    dispatch(
      bookActions.launchBridgeBook(props.isbn, {
        context: `bridge-book-details-panel ${props.context}`
      })
    )
});

const HeaderWithTheme = withTheme(Header);

export const LicensedHeader = connect(
  jigsawMapStateToProps,
  jigsawMapDispatchToProps
)(HeaderWithTheme);
export const BridgeHeader = connect(
  bridgeMapStateToProps,
  bridgeMapDispatchToProps
)(HeaderWithTheme);
